import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';

interface Props {
  data: any[];
  show: boolean;
  onCancel: () => void;
  onAdd: () => void;
  onClose: () => void;
}

const CHUNK_SIZE = 50;

const MultipleUserModal: React.FC<Props> = ({
  data,
  show,
  onCancel,
  onClose,
  onAdd,
}) => {
  const [visibleCount, setVisibleCount] = useState(5);

  const handleShowMore = () => {
    setVisibleCount(prev => Math.min(prev + CHUNK_SIZE, data.length));
  };

  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      dialogClassName={styles.multiple_dialog_content}
    >
      <Modal.Header closeButton>
        <Modal.Title>Multiple Employee Addition</Modal.Title>
      </Modal.Header>

      <p className={styles.previewDescription}>
        The employees have been added successfully. A summary of the added
        records is shown below
      </p>

      <Modal.Body className={styles.multiple_previewModal}>
        <div className={styles.scrollTable}>
          <table className={styles.previewTable}>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email ID</th>
                <th>Employee Code</th>
              </tr>
            </thead>
            <tbody>
              {data.slice(0, visibleCount).map((row, i) => (
                <tr key={i}>
                  <td>{row.FirstName}</td>
                  <td>{row.LastName}</td>
                  <td>{row.Email}</td>
                  <td>{row.EmployeeCode}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {data.length > visibleCount && (
          <div className={styles.moreCount}>
            +{data.length - visibleCount} more
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className={styles.multiple_modalActions}>
        <div className={styles.buttonWrapper}>
          <button className={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
          <button
            className={styles.addBtn}
            onClick={() => {
              onAdd();
              onClose();
            }}
          >
            Add
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default MultipleUserModal;
